module.exports = __webpack_public_path__ + "img/01.8091d3c2.png";